<template>
  <div class="smsTemplate">
    <div class="query">
      <div>
        模板名称:
        <el-input
          style="width: 150px"
          placeholder="请输入模版名称"
          clearable
          size="mini"
          @keyup.enter.native="findTemplatePageList"
          v-model="queryParam.templateName"
          prefix-icon="el-icon-user"
        ></el-input>
        <el-button
          type="primary"
          circle
          plain
          size="mini"
          @click="findTemplatePageList"
          icon="el-icon-search"
        ></el-button>
      </div>
      <div>
        <el-button type="primary" plain size="mini" @click="addTemplate"
          >新增模板</el-button
        >
      </div>
    </div>
    <br />
    <el-table
      :data="tableData"
      style="width: 100%"
      :hide-on-single-page="singleShow"
      stripe
      border
    >
      <el-table-column
        prop="templateName"
        label="模板名称"
        width="150"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="templateContent"
        label="模版内容"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="申请描述"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="审核状态" width="180">
        <template slot-scope="scope">
          <el-popover
            placement="bottom"
            width="200"
            trigger="click"
            :content="scope.row.reason"
          >
            <el-button
              v-if="scope.row.templateStatus == -1"
              slot="reference"
              type="text"
              class="t_wait"
              >待审核</el-button
            >
            <el-button
              v-if="scope.row.templateStatus == 0"
              slot="reference"
              type="text"
              class="t_wait"
              >审核中</el-button
            >
            <el-button
              v-if="scope.row.templateStatus == 1"
              slot="reference"
              type="text"
              class="t_success"
              >审核通过</el-button
            >
            <el-button
              v-if="scope.row.templateStatus == 2"
              slot="reference"
              type="text"
              class="t_error"
              >审核失败</el-button
            >
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="
              scope.row.templateStatus == -1 || scope.row.templateStatus == 2
            "
            @click="audit(scope.row)"
            size="mini"
            type="primary"
            icon="el-icon-s-check"
            plain
            >提交审核</el-button
          >
          <el-button
            v-if="scope.row.templateStatus == 0"
            @click="sysn(scope.row)"
            size="mini"
            type="warning"
            icon="el-icon-refresh"
            :loading="sysnload"
            plain
            >同步审核结果</el-button
          >
           <el-button
            v-if="scope.row.templateStatus == -1 || scope.row.templateStatus == 2"
            @click="edit(scope.row)"
            size="mini"
            type="warning"
            icon="el-icon-edit"
            plain
            >修改</el-button
          >
          <el-button
            @click="del(scope.row)"
            v-if="scope.row.templateStatus == -1 || scope.row.templateStatus == 2"
            size="mini"
            type="danger"
            icon="el-icon-delete"
            plain
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24" align="right">
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="paginations.page_index"
          :page-sizes="paginations.page_sizes"
          :page-size="paginations.page_size"
          :layout="paginations.layout"
          :total="paginations.total"
        ></el-pagination>
      </el-col>
    </el-row>
    <el-dialog
      :title="smsTemplateData.title"
      v-if="smsTemplateData.show"
      :visible.sync="smsTemplateData.show"
      width="35%"
    >
      <sms-template-dialog
        :smsData="smsTemplateData"
        @result="findTemplatePageList"
      ></sms-template-dialog>
    </el-dialog>
  </div>
</template>

<script>
import {
  findTemplatePageList,
  auditTemplate,
  deleteTemplate,
  sysnTemplate,
} from "@/api/index";
import SmsTemplateDialog from "./SmsTemplateDialog.vue";

export default {
  components: {
    SmsTemplateDialog,
  },
  data() {
    return {
      singleShow: false,
      queryParam: {
        templateName: "",
      },
      tableData: [],
      paginations: {
        page_index: 1, //当前位于哪页
        total: 0, //总数
        page_size: 5, //每页显示多少条
        page_sizes: [5, 10, 20], //下拉选择
        layout: "total, sizes, prev, pager, next, jumper",
      },
      smsTemplateData: {
        title: "",
        show: false,
        id: null,
      },
      sysnload: false,
    };
  },
  methods: {
    findTemplatePageList() {
      let that = this;
      findTemplatePageList({
        templateName: this.queryParam.templateName,
        pageIndex: this.paginations.page_index,
        size: this.paginations.page_size,
      }).then((res) => {
        if (res.success == true) {
          that.tableData = res.result.list;
          this.paginations.total = res.result.total;
        } else {
          this.$notify.error({
            title: "错误",
            message: res.message,
          });
        }
      });
    },
    handleSizeChange(val) {
      this.paginations.page_size = val;
      this.findTemplatePageList();
    },
    handleCurrentChange(val) {
      this.paginations.page_index = val;
      this.findTemplatePageList();
    },
    addTemplate() {
      this.smsTemplateData.title = "新增模板";
      this.smsTemplateData.show = true;
      this.smsTemplateData.operation = "add";
    },
    audit(data) {
      auditTemplate(data.id).then((res) => {
        if (res.success == true) {
          this.$message({
            showClose: true,
            message: "提交审核成功",
            type: "success",
          });
          this.findTemplatePageList();
        } else {
          this.$notify.error({
            title: "错误",
            message: res.message,
          });
        }
      });
    },
    sysn(data) {
      this.sysnload = true;
      sysnTemplate(data.id).then((res) => {
        if (res.success == true) {
          this.$message({
            showClose: true,
            message: "查询成功",
            type: "success",
          });
          this.sysnload = false;
          this.findTemplatePageList();
        } else {
          this.$notify.error({
            title: "错误",
            message: res.message,
          });
        }
      });
    },
    edit(data) {
      this.smsTemplateData.title = "修改模板";
      this.smsTemplateData.show = true;
      this.smsTemplateData.operation = "edit";
      this.smsTemplateData.id = data.id
    },
    del(data) {
      deleteTemplate(data.id).then((res) => {
        if (res.success == true) {
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.findTemplatePageList();
        } else {
          this.$notify.error({
            title: "错误",
            message: res.message,
          });
        }
      });
    },
  },
  created() {
    this.findTemplatePageList();
  },
};
</script>

<style lang="scss">
.smsTemplate {
  .el-dialog__body {
    padding: 20px;
  }
  .el-table__body tr.current-row > td {
    background: #f56c6c !important;
    color: #ffffff;
  }
  .query {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .el-table {
    .success-row {
      background: #f0f9eb;
    }
  }
  .t_wait {
    color: gray;
  }
  .t_success {
    color: #67c23a;
  }
  .t_error {
    color: #f56c6c;
  }
}
</style>